import * as CONSTS from 'redux/constants/global';

export const displaySpinner = ({ props = null, meta = { notifySdk: true } } = {}) => ({
  type: CONSTS.SET_IS_LOADING,
  payload: {
    loading: true,
    loadingProps: props
  },
  meta
});

export const hideSpinner = ({
  props = null,
  meta = { notifySdk: true, pageType: '' }
} = {}) => ({
  type: CONSTS.SET_IS_LOADING,
  payload: {
    loading: false,
    loadingProps: props
  },
  meta
});

export const setSessionId = (_, sessionId) => ({
  type: CONSTS.SET_SESSION_ID,
  payload: {
    sessionId
  }
});

export const setConfigData = data => ({
  type: CONSTS.SET_CONFIG_DATA,
  payload: data
});

export const setSdkParams = (data = {}, embedded = false) => ({
  type: CONSTS.SET_SDK_PARAMS,
  payload: data,
  meta: { embedded }
});

export const setCustomStyles = data => ({
  type: CONSTS.SET_CUSTOM_STYLES,
  payload: data
});

export const setIsMobile = data => ({
  type: CONSTS.SET_IS_MOBILE,
  payload: data
});

export const setIsDemo = data => ({
  type: CONSTS.SET_IS_DEMO,
  payload: data
});

export const setIsPreview = data => ({
  type: CONSTS.SET_IS_PREVIEW,
  payload: data
});

export const setPreviewConfig = data => ({
  type: CONSTS.SET_PREVIEW_CONFIG,
  payload: data
});

export const showModal = ({ type, props }) => ({
  type: CONSTS.SHOW_MODAL,
  payload: {
    type,
    props
  }
});

export const updateModalGeneralProps = props => ({
  type: CONSTS.UPDATE_MODAL_GENERAL_PROPS,
  payload: {
    props
  }
});

export const updateModalPrimaryButtonProps = props => ({
  type: CONSTS.UPDATE_MODAL_PRIMARY_BUTTON_PROPS,
  payload: {
    props
  }
});

export const updateModalSecondaryButtonProps = props => ({
  type: CONSTS.UPDATE_MODAL_SECONDARY_BUTTON_PROPS,
  payload: {
    props
  }
});

export const hideModal = () => ({
  type: CONSTS.HIDE_MODAL
});

export const setMerchantData = data => ({
  type: CONSTS.SET_MERCHANT_DATA,
  payload: data
});

export const setGeoData = data => ({
  type: CONSTS.SET_GEO_DATA,
  payload: data
});

export const setPaymentAlertShown = data => ({
  type: CONSTS.SET_PAYMENT_ALERT_SHOWN,
  payload: { shown: data }
});

export const setABTestingData = data => ({
  type: CONSTS.SET_AB_TESTING,
  payload: data
});

export const setPageToken = data => ({
  type: CONSTS.SET_PAGE_TOKEN,
  payload: data
});

export const setFeatureFlags = data => ({
  type: CONSTS.SET_FEATURE_FLAGS,
  payload: data
});

export const setHostedPageType = data => ({
  type: CONSTS.SET_PAGE_TYPE,
  payload: data
});

export const setUserFirstPageUrl = data => ({
  type: CONSTS.SET_USER_FIRST_PAGE_URL,
  payload: data
});

export const showBanner = ({ props }) => ({
  type: CONSTS.SHOW_BANNER,
  payload: {
    props
  }
});

export const hideBanner = () => ({
  type: CONSTS.HIDE_BANNER
});

export const setPageCommonData = data => ({
  type: CONSTS.SET_COMMON_PAGE_DATA,
  payload: data
});
